import type { ComponentStyleConfig } from "@chakra-ui/theme";

const SectionRenderer: ComponentStyleConfig = {
	baseStyle: {
		jumpLinkWrapper: {
			position: "relative",
		},
		jumpLink: {
			fontWeight: "500",
			color: "white",
			bg: "gray.medium",
			position: "absolute",
			top: 4,
			right: 0,
			padding: 2,
			borderLeftRadius: "md",
		},
		scrollButton: {
			position: "fixed",
			right: { base: 6, lg: 12 },
			bottom: { base: 6, lg: 12 },
			zIndex: 2,
		},
	},
};

export default SectionRenderer;
